<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo-gigainlab.png" />
    <div v-if="Object.keys(customer).length !== 0 && !customer.livemode">
      <span class="tag is-warning">STRIPE TEST MODE</span>
    </div>
    <section class="container">
      <hr />
      <h1 class="title">Associazione carta di credito</h1>

      <div>
        I dati della carta di credito vengono trasmessi in
        <a href="https://it.wikipedia.org/wiki/HTTPS" target="_blank"
          >modalità sicura</a
        >
        direttamente al servizio di pagamenti
        <a href="https://stripe.com/it-IT/" target="_blank">Stripe</a>.
      </div>

      <div v-if="!route_customer_id">
        <hr />
        Per essere <b>correttamente identificato</b> accedi dal link che ti è
        stato <b>inviato per email</b>! Grazie 😊
      </div>
      <template v-else>
        <div v-if="paymentMethods && paymentMethods.object === 'list'">
          <ul
            style="margin-top:30px; font-size: .888em; font-family: monospace;"
          >
            <li
              v-for="(pm, index) in paymentMethods.data"
              :key="`pm_${pm.id}_${index}`"
            >
              <b>{{ pm.billing_details.name }}</b
              >: **** **** ****
              <b>{{ pm.card.last4 }}</b>
              {{ pm.card.exp_month }}/{{ pm.card.exp_year }}
            </li>
          </ul>
        </div>
        <StripeNewCard
          :isLoading="isLoading"
          :customer="customer"
          :setupIntent="setupIntent"
          v-on:eventSetupIntent="handleSetupIntent"
        />
      </template>
      <!--
      <pre style="text-align:left">
            {{this.customer}}
      </pre>-->
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import StripeNewCard from "@/components/StripeNewCard.vue";
import axios from "axios";
import getError from "../plugins/AjaxGetError.js";

export default {
  name: "credit-card-view",
  components: {
    StripeNewCard,
  },
  data() {
    return {
      isLoading: false,
      route_customer_id: null,
      customer: {},
      paymentMethods: {},
      setupIntent: {},
    };
  },
  methods: {
    // afferma intent al backend
    handleSetupIntent(customer_id, payment_method_id, cardElement) {
      let self = this;
      this.isLoading = true;

      this.axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/customer/card/add/intent`, {
          customerId: customer_id,
          paymentMethodId: payment_method_id,
        })
        .then((response) => {
          this.customer = response.data;
          cardElement.clear();

          self.$dialog.alert({
            title: "Operazione completata",
            message:
              "Hai aggiornato i tuoi dettagli di pagamento.<br>Puoi chiudere questa pagina.",
            confirmText: "OK",
            scroll: "keep",
            type: "is-success",
            hasIcon: true,
          });
        })
        .catch((e) => {
          self.$dialog.alert({
            message: getError.AjaxGetError(e),
            confirmText: "OK",
            scroll: "keep",
            type: "is-danger",
            hasIcon: true,
          });
        })
        .finally(() => (self.isLoading = false));
    },
  },
  // system ready
  created() {
    let self = this;
    this.route_customer_id = this.$route.params.customer_id;
    this.isLoading = true;

    // get customer's info and create intent
    if (this.route_customer_id) {
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/customer/${this.route_customer_id}`
        )
        .then((response) => {
          this.customer = response.data.customer;
          this.paymentMethods = response.data.paymentMethods;
          this.setupIntent = response.data.setupIntent;
        })
        .catch((e) => {
          let self = this;
          self.$dialog.alert({
            message: getError.AjaxGetError(e),
            confirmText: "OK",
            scroll: "keep",
            type: "is-danger",
            hasIcon: true,
          });
        })
        .finally(() => (self.isLoading = false));
    }
  },
};
</script>
